<template>
  <div id="SectionPipeline">
    <UIContainer class="SectionPipeline__container">
      <SectionTitle class="SectionPipeline__title">
        <template #title> A governed pipeline for all your data </template>

        <template #description>
          Start with the platform, add expert lift when needed - same data,
          same<br />
          evidence, zero rework.
        </template>
      </SectionTitle>

      <div class="SectionPipeline__image-container">
        <img
          src="./images/pipeline/chart.avif"
          alt="Pipeline"
          class="SectionPipeline__image"
          loading="lazy"
        />
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
</script>

<style lang="scss" scoped>
#SectionPipeline {
  padding-bottom: 3rem;

  @include md {
    padding-bottom: 6rem;
  }

  .SectionPipeline__container {
    background-color: #011a18;
    border-radius: 2.5rem;
  }

  .SectionPipeline__title {
    text-align: center;
    margin: 0 auto 1rem;
    max-width: 48rem;

    :deep(.SectionTitle__title) {
      color: $color-white;
    }

    :deep(.SectionTitle__description) {
      color: $color-ui-gray-cool-300;
    }
  }

  .SectionPipeline__image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1rem;

    @include md {
      padding: 0 2rem;
    }
  }

  .SectionPipeline__image {
    margin-top: 2rem;
    width: 100%;
    height: auto;

    @include md {
      margin-top: 4rem;
      max-height: 336px;
      height: auto;
    }
  }
}
</style>
